import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function() {
    var slider = document.querySelector( '.home-team .dr-slider' );
    
    if( slider ) {
        var splide = new Splide( slider, {
            pagination: false,
            arrows: false
        } );
        
        var thumbnails = document.querySelectorAll( '.home-team .slider-thumbnails li' );
        var current;
        
        if( thumbnails ) {
            for ( var i = 0; i < thumbnails.length; i++ ) {
                initThumbnail( thumbnails[ i ], i );
            }
            
            
            function initThumbnail( thumbnail, index ) {
                thumbnail.addEventListener( 'click', function () {
                splide.go( index );
                } );
            }
        }
        
        splide.on( 'mounted move', function () {
            var thumbnail = thumbnails[ splide.index ];
        
        
            if ( thumbnail ) {
            if ( current ) {
                current.classList.remove( 'is-active' );
            }
        
        
            thumbnail.classList.add( 'is-active' );
            current = thumbnail;
            }
        } );
        
        splide.mount();   
    }
});